export default {
  setAvailableWithdrawTypes(state, value) {
    state.availableWithdrawTypes = value
  },
  setWithdrawSortInfo(state, value) {
    state.withdrawSortInfo = value
  },
  setIsUsePcs(state, value) {
    state.isUsePcs = value
  },
  setWithdrawName(state, value) {
    state.withdrawName = value
  },
  setPCSI18n(state, value) {
    state.PCSI18n = value
  },
  setPercentageFee(state, value) {
    state.percentageFee = value
  },
  setCalculatedAmount(state, value) {
    state.calculatedAmount = value
  },
  setShowFee(state, value) {
    state.showFee = value
  },
}
